import Vue from 'vue'

import * as Sentry from '@sentry/vue'
import { mapGetters, mapState } from 'vuex'
import storage from '@/services/storage'

// api
import ReactionAPI from '@/api/reaction'

const heart = require('@/assets/images/reactions/heart.png')
const heartActive = require('@/assets/images/reactions/heart-active.png')
const laugh = require('@/assets/images/reactions/laugh.png')
const laughActive = require('@/assets/images/reactions/laugh-active.png')
const like = require('@/assets/images/reactions/like.png')
const likeActive = require('@/assets/images/reactions/like-active.png')
const sad = require('@/assets/images/reactions/sad.png')
const sadActive = require('@/assets/images/reactions/sad-active.png')
const wow = require('@/assets/images/reactions/wow.png')
const wowActive = require('@/assets/images/reactions/wow-active.png')

export default (component) => Vue.component('ReactionsContainer', {
  data() {
    return {
      heart: {
        name: 'heart',
        icon: heart,
        iconActive: heartActive,
      },
      laugh: {
        name: 'laugh',
        icon: laugh,
        iconActive: laughActive,
      },
      like: {
        name: 'like',
        icon: like,
        iconActive: likeActive,
      },
      sad: {
        name: 'sad',
        icon: sad,
        iconActive: sadActive,
      },
      wow: {
        name: 'wow',
        icon: wow,
        iconActive: wowActive,
      },
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audienceName: (state) => state.audienceName,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  created() {
    this.setReactionActive(null)
  },
  methods: {
    setReactionActive(reactionType) {
      const reactionsCache = storage.getValueByPresentation(this.presentation.id, 'reactionsByPesentation', [])
      if (reactionsCache.includes('heart') || reactionType === 'heart') {
        this.heart = { ...this.heart, ...{ active: true } }
      }
      if (reactionsCache.includes('laugh') || reactionType === 'laugh') {
        this.laugh = { ...this.laugh, ...{ active: true } }
      }
      if (reactionsCache.includes('like') || reactionType === 'like') {
        this.like = { ...this.like, ...{ active: true } }
      }
      if (reactionsCache.includes('sad') || reactionType === 'sad') {
        this.sad = { ...this.sad, ...{ active: true } }
      }
      if (reactionsCache.includes('wow') || reactionType === 'wow') {
        this.wow = { ...this.wow, ...{ active: true } }
      }
    },
    async react(reactionType) {
      if (!this.slide.id) return
      const payload = {
        audienceId: this.audienceId,
        audienceName: this.audienceName,
        slideId: this.slide.id,
        presentationId: this.presentation.id,
        reactionType,
      }
      this.setReactionActive(reactionType)
      try {
        await ReactionAPI.createReaction(payload)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
  render(createElement) {
    if (!this.slide.id) return null
    return createElement(component, {
      props: {
        ...this.$attrs,
        react: this.react,
        presentation: this.presentation,
        heart: this.heart,
        laugh: this.laugh,
        like: this.like,
        sad: this.sad,
        wow: this.wow,
      },
    })
  },
})
